import { Component } from '@angular/core';
import { PageHeaderComponent } from '../core/labels/page-header.component';
import { HomeCardComponent } from '../home/home-card.component';
import { DistributedReportsComponent } from '../reports/distributed-report/distributed-reports.component';

@Component({
  selector: 'app-external-distributed-reports-page',
  imports: [
    DistributedReportsComponent,
    HomeCardComponent,
    PageHeaderComponent,
  ],
  template: `
    <app-page-header label="Distributed reports" headerSize="h1" />
    <app-home-card type="Large">
      <div class="tw-min-w-0 tw-w-[100%] tw-pb-8">
        <app-distributed-reports [showHeader]="false" [externalAccess]="true" />
      </div>
      <div class="tw-pb-8">
        <div class="tw-py-8 tw-italic tw-text-sm">
          Please note: Reports will be available for 120 days after the
          requested date.
        </div>
        <div class="tw-italic tw-text-sm">
          Distributed reports are reports that have been shared with you by
          another user through email.
        </div>
      </div>
    </app-home-card>
  `,
  styles: ``,
})
export class ExternalDistributedReportsPageComponent {}
